import React from 'react';
export var Logo = function Logo(_a) {
  var className = _a.className;
  return React.createElement("img", {
    src: "https://s3.ap-south-1.amazonaws.com/io.vlinder.public/vlinder-logo.png",
    width: 50,
    height: 50
  });
};